<template>
	<div>
		<div class="d21-language-select">
			<d21-select :list="this.languages"></d21-select>
		</div>
		<div id="d21-contact">
			<div class="d21-block">
				<ValidationObserver ref="observer" v-slot="{ passes }">
					<form @submit.prevent="passes(() => {})" onkeydown="return event.key != 'Enter';">
						<div class="mdl-grid">
							<div id="d21-contact-header" v-if="Channel.Address">
								<template v-if="Channel.Theme.Images && Channel.Theme.Images.Logo">
									<img :src="Channel.Theme.Images.Logo" :style="logoWidth" />
								</template>
								<div>
									<span>{{ Channel.Address.Venue.Name }}</span><br />
									{{ Channel.Address.Venue.AddressLine1 }}<br />
									{{ Channel.Address.Venue.PostalCode }} {{ Channel.Address.Venue.City }}<br />
								</div>
							</div>
						</div>
						<div class="mdl-grid d21-contact-persons" v-if="!isCheckout">
							<div class="d21-text" v-if="isSwitzerland">
								{{ T("OneTicketing_Covid19_DataCollectionNote_Switzerland") }}
								<br /><br />
							</div>
							<div class="d21-text" v-else>
								{{ T("OneTicketing_Covid19_DataCollectionNote") }}
								<br /><br />
							</div>
							<label class="text-header">
								{{ T("OneTicketing_Registration_Data") + ":" }}
							</label>
							<div class="mdl-grid d21-contact-location">
								<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-if="Channel.Fields.Location.IsVisible && Channel.Fields.Location.IsRequired">
									<label>{{ T("table_seat_number") + "*" }}</label>
									<ValidationProvider name="table_seat_number" rules="required" v-slot="{ errors }">
										<input name="Location" v-model="Registration.Location.Text" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="no" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--4-col mdl-cell--12-col-m form-group" v-else-if="Channel.Fields.Location.IsVisible">
									<label>{{ T("table_seat_number") }}</label>
									<input name="Location" v-model="Registration.Location.Text" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="no" />
								</div>
							</div>
							<div class="mdl-grid d21-contact-person" v-for="(person, pIndex) in Registration.Persons" :key="'person_' + pIndex">
								<label>
									{{ T("person") + " " + (pIndex + 1) }}
									<i class="material-icons" v-if="pIndex > 0" v-on:click="removePerson(pIndex)">close</i>
								</label>
								<div class="mdl-cell mdl-cell--5-col mdl-cell--6-col-m form-group required">
									<label>{{ T("firstname") + "*" }}</label>
									<ValidationProvider name="firstname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
										<input :name="'givenname_' + pIndex" v-model.trim="person.Givenname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="given-name" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--5-col mdl-cell--6-col-m form-group required">
									<label>{{ T("lastname") + "*" }}</label>
									<ValidationProvider name="lastname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
										<input :name="'lastname_' + pIndex" v-model.trim="person.Lastname" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="family-name" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div v-if="isSwitzerland || !Channel.Fields.AddressLine1.IsVisible" class="mdl-cell mdl-m--hidden" :class="[Channel.Fields.City.IsVisible? ' mdl-cell--8-col':'mdl-cell--5-col']">&nbsp;</div>
								<div v-if="Channel.Fields.AddressLine1.IsVisible" class="mdl-cell mdl-cell--10-col mdl-cell--12-col-m form-group required">
									<label>{{ T("street_and_street_number")}}{{Channel.Fields.AddressLine1.IsRequired ? "*" : '' }}</label>
									<ValidationProvider name="street_and_street_number" :rules="{ regex: /[a-zA-Z0-9.]+\s\d/, required: Channel.Fields.AddressLine1.IsRequired, min: 5 }" v-slot="{ errors }">
										<input name="street_and_street_number" v-model.trim="person.Address.AddressLine1" @keyup="removeUnallowedCharacters" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="shipping street-address" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>

								<div class="mdl-cell mdl-cell--3-col mdl-m--hidden" v-if="Channel.Fields.City.FsVisible">&nbsp;</div>


								<div v-if="Channel.Fields.City.IsVisible" class="mdl-cell mdl-cell--5-col mdl-cell--5-col-m form-group required">
									<label>{{ T("Address.ZIP")}}{{Channel.Fields.City.IsRequired ? "*" : ""}}</label>
									<ValidationProvider name="Address.ZIP" :rules="Channel.Fields.City.IsRequired ? 'required' : ''" v-slot="{ errors }">
										<input :name="'postalcode_' + pIndex" v-model="person.Address.PostalCode" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="postal-code" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div v-if="Channel.Fields.City.IsVisible" class="mdl-cell mdl-cell--5-col mdl-cell--7-col-m form-group">
									<label>{{ T("location")}}{{Channel.Fields.City.IsRequired ? "*" : ""}}</label>
									<ValidationProvider name="location" :rules="Channel.Fields.City.IsRequired ? 'required|alpha_spaces' : 'alpha_spaces'" v-slot="{ errors }">
										<input :name="'location' + pIndex" v-model="person.Address.City" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="address-level2" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--5-col mdl-cell--12-col-m form-group required">
									<label>{{ T("phone") + "*" }}</label>
									<ValidationProvider name="phone" rules="required|min:6" v-slot="{ errors }">
										<input :name="'mobile_' + pIndex" v-model="person.Communication.Phone" type="number" class="mdl-textfield__input" data-lpignore="true" autocomplete="tel" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--5-col mdl-cell--12-col-m form-group required" v-if="pIndex === 0">
									<label>{{ T("email") + "*" }}</label>
									<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
										<input :name="'email_' + pIndex" v-model.trim="person.Communication.Email" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--5-col mdl-cell--12-col-m form-group required" v-if="pIndex === 0">
									<label>{{ T("repeat_email") + "*" }}</label>
									<ValidationProvider name="repeat_email" rules="required|email|emailConfirm:@email" v-slot="{ errors }">
										<input :name="'emailrepeat_' + pIndex" v-model.trim="person.Communication.EmailRepeat" type="text" class="mdl-textfield__input" data-lpignore="true" autocomplete="email" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
								<div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-m form-group required" v-if="Channel.Fields.DateOfBirth && Channel.Fields.DateOfBirth.IsVisible && Channel.Fields.DateOfBirth.IsRequired">
									<label>{{ T("date of birth") }}{{Channel.Fields.DateOfBirth.IsRequired ? "*" : ""}}</label>
									<ValidationProvider name="date of birth" :rules="Channel.Fields.DateOfBirth.IsRequired ? 'required|dateFormat:DD.MM.YYYY' : 'dateFormat:DD.MM.YYYY'" v-slot="{ errors }">
										<input :name="'dateofbirth_' + pIndex" v-model="person.DateOfBirth" type="text" v-mask="'##.##.####'" placeholder="TT.MM.JJJJ" class="mdl-textfield__input" data-lpignore="true" />
										<span class="error">{{ errors[0] }}</span>
									</ValidationProvider>
								</div>
							</div>
							<div id="d21-contact-person-new" v-on:click="setPersons(Registration.Persons.length + 1)"><i class="material-icons">add</i> {{ T("add_person") }} </div>
							<div id="d21-contact-person-requiredfields">{{ "*" + T("mandatory_field") }}</div>
						</div>
						<div class="mdl-grid" v-if="Registration.Questions && Registration.Questions.length > 0">
							<template v-for="(question, iQuestion) in Registration.Questions">
								<div :key="'question_' + iQuestion" class="fullWidth">
									<label class="text-header">
										{{ question.Header }}
									</label>
									<div class="mdl-cell mdl-cell--12-col" v-if="question.IsRequired">
										<ValidationProvider :rules="question.IsRequired ? 'required' : ''" v-slot="{ errors }">
											<input :name="'question_' + iQuestion" type="text" class="mdl-textfield__input" data-lpignore="true" placeholder="Antwort" v-model.trim="question.Answer" />
											<span class="error" v-if="errors[0]">{{ T("OneTicketing_Please_Answer") }}</span>
										</ValidationProvider>
									</div>
								</div>
							</template>
						</div>
						<div class="mdl-grid" v-if="!isCheckout && !isEdit">
							<div class="d21-terms mdl-cell mdl-cell--12-col">
								<template v-for="(term, iTerm) in Channel.Terms.Items">
									<ValidationProvider :name="term.Name" rules="requiredCb" v-slot="{ errors }" :key="'terms_' + iTerm">
										<input v-model="term.isAccepted" type="checkbox" :name="'term_' + iTerm" value="terms" :id="'terms_' + iTerm" />
										<label :for="'terms_' + iTerm">{{ term.Text }}: <a target="_blank" :href="'https://api-default.tocc.dirs21.de/v1/cdn' + term.File.URI">{{ T("view_here") }}</a></label>
										<span class="errors"><template v-if="errors.length > 0">{{ T("OneTicketing_Please_Accept") + " " + T("terms") }}</template></span>
									</ValidationProvider>
								</template>
								<ValidationProvider name="data_terms" rules="requiredCb" v-slot="{ errors }">
									<input v-model="Registration.IsTermsAccepted" type="checkbox" name="terms" value="terms" id="cb_terms" />
									<label for="cb_terms">
										{{ T("PrivacyPolicy_agreement") + ":" }} <a target="_blank" :href="privacyPolicyLink"> {{ T("view_here" )}} </a>
									</label>
									<span class="errors">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
						</div>
						<div class="mdl-grid d21-contact-checkout" v-if="isCheckout">
							<div class="mdl-cell mdl-cell--12-col">
								<i class="material-icons">check_circle</i>
								{{ T("CheckOut_success") }}<br /> {{ T("OneTicketing_Thanks_for_visit") }}
							</div>
						</div>
					</form>
				</ValidationObserver>
			</div>
		</div>
		<div class="d21-fixed-nav bottom" v-if="!isCheckout && !isReadOnly">
			<div>&nbsp;</div>
			<div class="d21-next">
				<button class="btn btn-primary" @click="next">
					<span v-if="isEdit">{{ T("save_changes") }}</span>
					<span v-else> {{ T("save") }} </span>
				</button>
			</div>
		</div>
		<Modal name="contact.editNotPossible" title="EditNotPossible" :actions="editNotPossibleModalActions">
			<div class="mdl-grid">
				<label class="text-header">
					<br />
					<span v-if="isCheckedOut">{{ T("OneTicketing_CheckedOut") }}</span>
					<span v-if="isCanceled">{{ T("OneTicketing_Cancelled") }}</span>
					<span v-if="isCheckedIn">{{ T("OneTicketing_CheckedIn") }}</span>
					<br /><br />
				</label>
			</div>
		</Modal>
	</div>
</template>

<script>
	import baseMixin from "../mixins/base";
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import Vue from 'vue';
	import ToggleButton from 'vue-js-toggle-button'
	import 'vue2-dropzone/dist/vue2Dropzone.min.css'
	import Variables from "../scripts/_variables.js";
	import {
		ValidationProvider,
		ValidationObserver,
		extend
	} from "vee-validate";
	import {
		alpha_spaces,
		email,
		max,
		min,
		regex,
	} from "vee-validate/dist/rules";
	import VueMask from 'v-mask';
	import _hub from '../scripts/_hub';
	import Modal from './modal.vue';

	Vue.use(VueMask);
	Vue.use(ToggleButton);

	export default {
		mixins: [baseMixin],
		components: {
			ValidationProvider,
			ValidationObserver,
			Modal
		},
		name: "d21-contact",
		computed: {
			editNotPossibleModalActions() {
				return [{
					text: 'Ok',
					onClick: () => {
						this.$modals.hide("contact.editNotPossible");
					},
					isPrimary: true
				}];
			},
			isCheckedOut() {
				return this.Registration.Status === "CheckedOut";
			},
			isCanceled() {
				return this.Registration.Status === "Cancelled";
			},
			isCheckedIn() {
				return this.Registration.Status === "CheckedIn";
			},
			modalWidth() {
				return this.isMobile ? '90%' : '900';
			},
			isOwnerCharactersInvalid() {
				var pattern = "[^A-Za-z':?,\\-\\ (+.)/]";
				return true;
			},
			isCheckout() {
				return this.$route.name === "register_checkout";
			},
			isEdit() {
				return this.loadedRegistration !== null && !this.isCheckout;
			},
			isSwitzerland() {
				return window.location.hostname.endsWith('.ch');
			},
			isReadOnly() {
				return this.Registration && this.Registration.Status !== "Active" && this.Registration.Status !== "CheckedIn";
			}
		},
		data() {
			return {
				showEditNotPossible: false,
				loadedRegistration: null,
				data: null,
				creditCardUrl: null,
				Variables: Variables,
				ibanIsInvalid: false,
				isPosted: false,
				isLoading: false,
				languages: ['de-DE', 'en-US', 'fr-FR', 'it-IT'],
				validation: {
					errors: []
				},
				TemplatePerson: {
					Givenname: null,
					Lastname: null,
					DateOfBirth: null,
					Communication: {
						Email: null,
						EmailRepeat: null,
						Mobile: null
					},
					Address: {
						AddressLine1: null,
						PostalCode: null,
						City: null
					}
				},
				privacyPolicyLink: null
			};
		},
		mounted() {
			if (this.$route.params.code) this.loadRegistration(this.$route.params.code, this.checkOut);
			else this.setPersons(1);
		},
		created() {
			if (this.Channel.Questions) {
				this.Registration.Questions = [];
				this.Channel.Questions.forEach(q => this.Registration.Questions.push({
					Header: q.Header,
					Answer: null,
					IsRequired: q.IsRequired
				}));
			}

			extend("alpha_spaces", alpha_spaces);
			extend("email", email);
			extend("min", min);
			extend("max", max);
			extend("regex", regex);

			if (_hub.culture === "de-DE") this.privacyPolicyLink = "/OBT_ Datenschutz _DE_TOS.pdf";
			else this.privacyPolicyLink = "/OBT_PrivacyPolicy_EN_TOS.pdf";
		},
		methods: {
			next() {
				this.save();
			},
			removeUnallowedCharacters(e) {
				e.target.value = e.target.value.replaceAll(/[^A-zÀ-ú0-9 \\+/.:,#&-]/g, '');
			},
			checkOut() {
				if (this.isCheckout) {
					var command = `/registration/checkout/${this.$route.params.channel}/${this.$route.params.code}`;
					this.apiRequest(command, null, "GET", response => {
						if (!response.Value) console.log("checkout failed");
					});
				}
			},
			loadRegistration(code, cb) {
				var command = `/registration/${this.$route.params.channel}/${code}`;
				this.apiRequest(command, null, "GET", response => {
					if (response.Value) {
						if (response.Value.Status !== 'Active' && response.Value.Status !== 'CheckedIn') {
							this.Registration.Status = response.Value.Status;
							this.$modals.show("contact.editNotPossible");
						} else {
							this.Registration.Status = response.Value.Status;
							this.Registration.Persons = response.Value.Persons;
							this.Registration.Persons[0].Communication.EmailRepeat = response.Value.Persons[0].Communication.Email;
							this.Registration.Location.Text = response.Value.Location.Text;
							this.loadedRegistration = response.Value;
						}
					}
					cb();
				});
			},
			addEvent() {
				this.$modals.show("events");
			},
			setPersons(count) {
				while (this.Registration.Persons.length < count) this.Registration.Persons.push(JSON.parse(JSON.stringify(this.TemplatePerson)));
				while (this.Registration.Persons.length > count) this.Registration.Persons.splice(this.Registration.Persons.length - 1, 1);
			},
			removePerson(index) {
				this.Registration.Persons.splice(index, 1);
				window.event.stopPropagation();
			},
			eventClass(event) {
				let cssClass = "mdl-cell mdl-cell--12-col";
				if (event.isSelected) cssClass += " d21-event--selected";
				return cssClass;
			},
			tabLabelClass(person) {
				let cssClass = "d21-tab-label";
				if (person.isActive) cssClass += " d21-tab-label--active";
				return cssClass;
			},
			tabContentClass(person) {
				let cssClass = "mdl-grid d21-tab-content d21-person";
				if (person.isActive) cssClass += " d21-tab-content--active";
				return cssClass;
			},
			save() {
				this.validate(isValid => {
					if (isValid) {
						this.isLoading = true;
						this.isPosted = true;
						this.saveRegistration();
					} else {
						this.isLoading = false;
					}
				});
			},
			saveRegistration() {
				// maybe an existing registration was loaded to be modified
				var registration = this.loadedRegistration ? this.loadedRegistration : this.Registration;
				registration.Persons = this.Registration.Persons;
				registration.Location.Text = this.Registration.Location.Text;

				//
				var command = `/registration/checkin/${this.Channel.Directory}`;
				this.errorMessage = null;

				//
				this.apiRequest(command, registration, "POST", result => {
					if (result.Meta && result.Meta.IsValid && result.Value.IsValid) {
						this.validation.errors = [];
						this.$router.replace({
							name: "confirmation"
						});
						window.setTimeout(() => {
							EventBus.$emit("checkout_onAfterBook", result.Value);
							EventBus.$emit("loading_end");
						}, 100);
					} else {
						this.isLoading = false;
						if (result.Value && result.Value.Validation.Errors) {
							this.validation.errors = result.Value.Validation.Errors;
							this.$modals.show("validation");
						} else {
							this.validation.errors = [result.Meta.Message];
						}
						EventBus.$emit("loading_end");
					}
				});
			},
			validate(cb) {
				this
					.$refs
					.observer
					.validate()
					.then(isValid => cb(isValid));
			},
			buildQuestionaire() {}
		},
		watch: {
			isLoading(newValue) {
				EventBus.$emit(newValue ? "loading_start" : "loading_end");
			}
		}
	};
</script>